import React, { useEffect, useState } from 'react';
import SalesOverview from './SalesOverview';
import ProductsMetricsChart from './ProductsMetricsChart';
import RecentOrders from './RecentOrders';
import TopProduct from './TopProduct';
import CustomerGrowth from './CustomerGrowth';
import {
  fetchCustomerGrowth,
  fetchSalesOverview,
} from '../../../services/dashboard';
import { fetchCustomerStats } from '../../../services/customerApi';
import { fetchOrderStats, fetchOrders } from '../../../services/orderApi';

const Overview = () => {
  const [statsData, setStatsData] = useState([
    {
      id: 1,
      title: 'Total Orders',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F257003D]',
      icon: '/assets/admin/total-orders.svg',
      alt: 'total-orders',
    },
    {
      id: 2,
      title: 'Total Revenue',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F6A3033D]',
      icon: '/assets/admin/total-revenue.svg',
      alt: 'total-revenue',
    },
    {
      id: 3,
      title: 'Average Order Value',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#4392EE3D]',
      icon: '/assets/admin/average-order-value.svg',
      alt: 'average-order-value',
    },
  ]);

  const [customerMetrics, setCustomerMetrics] = useState([
    {
      id: 1,
      title: 'New Customers',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F257003D]',
      icon: '/assets/admin/new-customers.svg',
      alt: 'new-customers',
    },
    {
      id: 2,
      title: 'Registered Customers',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F6A3033D]',
      icon: '/assets/admin/registered-customers.svg',
      alt: 'registered-customers',
    },
    {
      id: 3,
      title: 'Returning Customers',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#4392EE3D]',
      icon: '/assets/admin/returning-customers.svg',
      alt: 'returning-customers',
    },
  ]);

  const [orderMetrics, setOrderMetrics] = useState([
    {
      id: 1,
      title: 'Orders Awaiting Shipment',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F257003D]',
      icon: '/assets/admin/orders-awaiting.svg',
      alt: 'orders-awaiting',
    },
    {
      id: 2,
      title: 'Orders Shipped',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F6A3033D]',
      icon: '/assets/admin/orders-shipped.svg',
      alt: 'orders-shipped',
    },
    {
      id: 3,
      title: 'Orders Delivered',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#4392EE3D]',
      icon: '/assets/admin/orders-delivered.svg',
      alt: 'orders-delivered',
    },
  ]);

  const [paymentMetrics, setPaymentMetrics] = useState([
    {
      id: 1,
      title: 'Pending Payments',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F257003D]',
      icon: '/assets/admin/pending-payments.svg',
      alt: 'pending-payments',
    },
    {
      id: 2,
      title: 'Failed Transactions',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#F6A3033D]',
      icon: '/assets/admin/failed-transactions.svg',
      alt: 'failed-transactions',
    },
    {
      id: 3,
      title: 'Refunds Processed',
      value: '-',
      percentage: '',
      isPositive: true,
      bgColor: 'bg-[#4392EE3D]',
      icon: '/assets/admin/refunds-processed.svg',
      alt: 'refunds-processed',
    },
  ]);

  const UpArrowIcon = () => (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.39378 8.54713C2.20048 8.88193 2.3152 9.31004 2.65 9.50334C2.9848 9.69664 3.41292 9.58193 3.60622 9.24713L2.39378 8.54713ZM8.17615 0.921723C8.07609 0.548296 7.69225 0.326689 7.31883 0.426748L1.23349 2.05731C0.860067 2.15737 0.63846 2.5412 0.738519 2.91463C0.838578 3.28806 1.22241 3.50966 1.59584 3.4096L7.00503 1.96022L8.45441 7.3694C8.55447 7.74283 8.93831 7.96444 9.31173 7.86438C9.68516 7.76432 9.90677 7.38048 9.80671 7.00706L8.17615 0.921723ZM3 8.89713L3.60622 9.24713L8.10622 1.4529L7.5 1.1029L6.89378 0.752896L2.39378 8.54713L3 8.89713Z"
        fill="#00C95C"
      />
    </svg>
  );

  const DownArrowIcon = () => (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.16197 0.323049C1.8886 0.0496819 1.44538 0.0496819 1.17202 0.323049C0.89865 0.596416 0.89865 1.03963 1.17202 1.313L2.16197 0.323049ZM8.03095 7.88199C8.41755 7.88199 8.73095 7.56858 8.73095 7.18199L8.73095 0.881985C8.73095 0.495386 8.41755 0.181985 8.03095 0.181985C7.64435 0.181985 7.33095 0.495386 7.33095 0.881985L7.33095 6.48199L1.73095 6.48198C1.34435 6.48198 1.03095 6.79539 1.03095 7.18198C1.03095 7.56858 1.34435 7.88199 1.73095 7.88199L8.03095 7.88199ZM1.66699 0.818024L1.17202 1.313L7.53598 7.67696L8.03095 7.18199L8.52593 6.68701L2.16197 0.323049L1.66699 0.818024Z"
        fill="#EE4343"
      />
    </svg>
  );

  const [salesData, setSalesData] = useState([]);
  const [regionsData, setRegionsData] = useState(null);
  const formatCurrency = (n) =>
    typeof n === 'number'
      ? `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`
      : '-';

  const MetricCard = ({ stat }) => (
    <div
      className="rounded-[16px] p-4 sm:p-7 h-full bg-white flex items-center justify-between gap-3 sm:gap-4"
      style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
    >
      <div
        className={`${stat.bgColor} rounded-[16px] h-10 w-10 sm:h-12 sm:w-12 flex items-center justify-center flex-shrink-0`}
      >
        <img src={stat.icon} alt={stat.alt} className="w-5 h-5 sm:w-6 sm:h-6" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 sm:gap-3 mb-0.5">
          <h2 className="text-[#373737] poppins text-[14px] sm:text-[16px] leading-[20px] sm:leading-[24px] tracking-[-0.64px] truncate">
            {stat.title}
          </h2>
          <button className="flex-shrink-0">
            <img src="/assets/admin/dots.svg" alt="dots" className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <h2 className="text-[24px] sm:text-[32px] leading-[32px] sm:leading-[48px] text-black font-semibold poppins truncate">
            {stat.value}
          </h2>
          <div className="flex-shrink-0">
            <div className="flex items-center gap-1 h-[21px]">
              {stat.isPositive ? <UpArrowIcon /> : <DownArrowIcon />}
              <h3
                className={`${
                  stat.isPositive ? 'text-[#00C95C]' : 'text-[#EE4343]'
                } text-[12px] sm:text-[14px] leading-[18px] sm:leading-[21px] font-medium poppins tracking-[-0.32px]`}
              >
                {stat.percentage}
              </h3>
            </div>
            <p className="text-[#636363] text-[10px] sm:text-[12px] leading-[14px] sm:leading-[18px] poppins tracking-[-0.64px]">
              From last month
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [s, r, stats] = await Promise.all([
          fetchSalesOverview(),
          fetchCustomerGrowth(),
          fetchOrderStats(),
        ]);
        if (mounted) {
          setSalesData(s);
          setRegionsData(r);
          if (stats) {
            const top = [
              {
                id: 1,
                title: 'Total Orders',
                value: (stats.totalOrders ?? 0).toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F257003D]',
                icon: '/assets/admin/total-orders.svg',
                alt: 'total-orders',
              },
              {
                id: 2,
                title: 'Total Revenue',
                value: formatCurrency(stats.totalRevenue ?? 0),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F6A3033D]',
                icon: '/assets/admin/total-revenue.svg',
                alt: 'total-revenue',
              },
              {
                id: 3,
                title: 'Average Order Value',
                value: formatCurrency(stats.averageOrderValue ?? 0),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#4392EE3D]',
                icon: '/assets/admin/average-order-value.svg',
                alt: 'average-order-value',
              },
            ];
            setStatsData(top);
            const awaiting =
              (stats.pendingOrders ?? 0) + (stats.processingOrders ?? 0);
            setOrderMetrics([
              {
                id: 1,
                title: 'Orders Awaiting Shipment',
                value: awaiting.toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F257003D]',
                icon: '/assets/admin/orders-awaiting.svg',
                alt: 'orders-awaiting',
              },
              {
                id: 2,
                title: 'Orders Shipped',
                value: (stats.shippedOrders ?? 0).toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F6A3033D]',
                icon: '/assets/admin/orders-shipped.svg',
                alt: 'orders-shipped',
              },
              {
                id: 3,
                title: 'Orders Delivered',
                value: (stats.deliveredOrders ?? 0).toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#4392EE3D]',
                icon: '/assets/admin/orders-delivered.svg',
                alt: 'orders-delivered',
              },
            ]);
          }
          // Customer metrics
          try {
            const cStats = await fetchCustomerStats();
            // Returning customers computed from recent orders
            const paramsRC = new URLSearchParams({
              page: '1',
              limit: '400',
              sortBy: 'createdAt',
              sortOrder: 'desc',
            });
            const { orders: oList } = await fetchOrders(paramsRC);
            const counts = new Map();
            for (const o of oList || []) {
              const cid = o.customerId || o.user || o.customer || o.userId;
              if (!cid) continue;
              counts.set(cid, (counts.get(cid) || 0) + 1);
            }
            let returning = 0;
            counts.forEach((n) => {
              if (n > 1) returning += 1;
            });
            const cm = [
              {
                id: 1,
                title: 'New Customers',
                value: (cStats?.newThisMonth ?? 0).toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F257003D]',
                icon: '/assets/admin/new-customers.svg',
                alt: 'new-customers',
              },
              {
                id: 2,
                title: 'Registered Customers',
                value: (cStats?.totalCustomers ?? 0).toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F6A3033D]',
                icon: '/assets/admin/registered-customers.svg',
                alt: 'registered-customers',
              },
              {
                id: 3,
                title: 'Returning Customers',
                value: returning.toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#4392EE3D]',
                icon: '/assets/admin/returning-customers.svg',
                alt: 'returning-customers',
              },
            ];
            setCustomerMetrics(cm);
          } catch (_) {
            /* keep defaults */
          }
          // Payment metrics derived from recent orders (first 200)
          try {
            const params = new URLSearchParams({
              page: '1',
              limit: '200',
              sortBy: 'createdAt',
              sortOrder: 'desc',
            });
            const { orders } = await fetchOrders(params);
            const counts = { pending: 0, failed: 0, refunded: 0 };
            for (const o of orders || []) {
              const k = (o.paymentStatus || '').toLowerCase();
              if (k === 'pending') counts.pending += 1;
              else if (k === 'failed') counts.failed += 1;
              else if (k === 'refunded') counts.refunded += 1;
            }
            setPaymentMetrics([
              {
                id: 1,
                title: 'Pending Payments',
                value: counts.pending.toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F257003D]',
                icon: '/assets/admin/pending-payments.svg',
                alt: 'pending-payments',
              },
              {
                id: 2,
                title: 'Failed Transactions',
                value: counts.failed.toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#F6A3033D]',
                icon: '/assets/admin/failed-transactions.svg',
                alt: 'failed-transactions',
              },
              {
                id: 3,
                title: 'Refunds Processed',
                value: counts.refunded.toLocaleString(),
                percentage: '',
                isPositive: true,
                bgColor: 'bg-[#4392EE3D]',
                icon: '/assets/admin/refunds-processed.svg',
                alt: 'refunds-processed',
              },
            ]);
          } catch (_) {
            /* keep defaults */
          }
        }
      } catch (e) {
        // keep fallbacks inside components
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="max-w-[1140px] w-full mx-auto px-4 sm:px-6 lg:px-0">
      {/* Header Section - Mobile Responsive */}
      {/* <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <div className="flex flex-wrap items-center gap-4 sm:gap-[25px]">
          {timeFilters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveTimeFilter(filter)}
              className={`py-1.5 text-[14px] leading-[21px] poppins transition-all duration-200 tracking-[-0.32px] ${
                activeTimeFilter === filter
                  ? "text-[#00001D] border-b-2 border-black font-semibold"
                  : "text-[#B9BCC6] hover:text-black font-normal"
              }`}
            >
              {filter}
            </button>
          ))}
        </div>
        <button className="flex items-center gap-1.5 border border-[#BBB8B826] bg-[#000000] rounded-[12px] h-[38px] py-2 px-6 text-[#BBB8B8] text-[12px] font-semibold tracking-[-0.64px] poppins">
          Export <img src="/assets/admin/export.svg" alt="export" />
        </button>
      </div> */}

      {/* Main Stats - Mobile Responsive */}
      <div className="my-[18px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {statsData.map((stat) => (
          <MetricCard key={stat.id} stat={stat} />
        ))}
      </div>

      {/* Charts Section - Mobile Responsive */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SalesOverview data={salesData} />
        <CustomerGrowth data={regionsData} />
      </div>

      {/* Recent Orders and Top Product - Mobile Responsive */}
      <div className="flex flex-col lg:flex-row gap-6 mt-6">
        <div className="w-full lg:w-2/3">
          <RecentOrders />
        </div>
        <div className="w-full lg:w-1/3">
          <TopProduct />
        </div>
      </div>

      {/* Customer Metrics - Mobile Responsive */}
      <div className="my-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {customerMetrics.map((stat) => (
            <MetricCard key={stat.id} stat={stat} />
          ))}
        </div>
      </div>

      {/* Product Analytics and Order Metrics - Mobile Responsive */}
      <div className="grid grid-cols-1 lg:grid-cols-2 items-start justify-between gap-6">
        {/* Products Metrics Chart */}
        <div className="mb-6">
          <div className="grid grid-cols-1 gap-6">
            <ProductsMetricsChart />
          </div>
        </div>

        {/* Order Metrics */}
        <div className="mb-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {orderMetrics.map((stat, index) => {
              const isLast = index === orderMetrics.length - 1;
              return (
                <div key={stat.id} className={isLast ? 'sm:col-span-2' : ''}>
                  <MetricCard stat={stat} />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Payment Metrics - Mobile Responsive */}
      <div className="mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {paymentMetrics.map((stat) => (
            <MetricCard key={stat.id} stat={stat} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
